(() => {
  'use strict';
  if (window.__SQ_SELECTED_OPTION_COMPACT_V1__) return;
  window.__SQ_SELECTED_OPTION_COMPACT_V1__ = true;

  const known = new Map([
    ['one size','OS'],['one-size','OS'],['extra small','XS'],['x-small','XS'],['small','S'],['medium','M'],['large','L'],['extra large','XL'],['x-large','XL'],['xx large','2XL'],['xx-large','2XL'],['2x large','2XL'],['2x-large','2XL'],['xxl','2XL'],['2xl','2XL'],['xxx large','3XL'],['3x large','3XL'],['xxxl','3XL'],['3xl','3XL']
  ]);

  function compact(value) {
    const full = String(value || '').replace(/\s+/g,' ').trim();
    if (!full) return { full:'Size', short:'Size' };
    const key = full.toLowerCase();
    if (known.has(key)) return { full, short:known.get(key) };
    const noSpace = full.replace(/\s+/g,'');
    if (noSpace.length <= 4) return { full, short:full };
    if (/^\d+\s*[-/–]\s*\d+$/.test(full)) return { full, short:full.replace(/\s+/g,'') };
    const words = full.split(' ').filter(Boolean);
    if (words.length > 1) {
      const initials = words.map(word => word[0]).join('').toUpperCase();
      if (initials.length <= 4) return { full, short:initials };
    }
    return { full, short:Array.from(words[0] || noSpace).slice(0,4).join('').toUpperCase() };
  }

  function apply(root = document) {
    root.querySelectorAll?.('[data-lcs-expanded-selected-list] .lcs-selected-size,.lcs-favorite-expanded__selected-list .lcs-selected-size').forEach(node => {
      const source = node.dataset.sqFullSelectedOption || node.textContent;
      const result = compact(source);
      node.dataset.sqFullSelectedOption = result.full;
      node.textContent = result.short;
      node.setAttribute('aria-label',result.full);
      node.title = result.full;
    });
  }

  let frame = 0;
  const schedule = () => { if (!frame) frame=requestAnimationFrame(()=>{frame=0;apply(document)}); };
  const observeExpandedRoots = () => {
    document.querySelectorAll('[data-lcs-expanded-controller],[data-lcs-favorite-expanded]').forEach(root => {
      if (!(root instanceof Element) || root.dataset.sqSelectedOptionObserver === 'true') return;
      root.dataset.sqSelectedOptionObserver = 'true';
      new MutationObserver(schedule).observe(root,{childList:true,subtree:true});
    });
  };
  const start = () => { apply(document); observeExpandedRoots(); };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded',start,{once:true}) : start();
  document.addEventListener('shopify:section:load',()=>{observeExpandedRoots();schedule()});
  document.addEventListener('predictive-search:updated',()=>{observeExpandedRoots();schedule()});
})();
